import { render, staticRenderFns } from "./FullSwiperV2.vue?vue&type=template&id=5b0948a8&scoped=true&"
import script from "./FullSwiperV2.vue?vue&type=script&lang=js&"
export * from "./FullSwiperV2.vue?vue&type=script&lang=js&"
import style0 from "./FullSwiperV2.vue?vue&type=style&index=0&id=5b0948a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0948a8",
  null
  
)

export default component.exports